import * as React from "react";
import { useTranslation } from 'react-i18next';

export const useFormConfig = () => {
    const { t } = useTranslation();
    
    return {
        config: { columns: 1 },
        fields: [
            {
                name: "oldQuantity",
                label: t("common.current_states"),
                type: "number",
                mandatory: true,
                readOnly: true,
                column: 1,
            },
            {
                name: "addQuantity",
                label: t("forms.added_quantity"),
                type: "number",
                mandatory: true,
                column: 1,
                validate: function (value) {
                    return parseInt(value) > 0;
                }
            },
            {
                name: "quantity",
                label: t("forms.add_to_warehouse"),
                type: "number",
                readOnly: true,
                column: 1,
                autoComplete: {
                    triggers: ["oldQuantity", "addQuantity"],
                    calculation: function (oldQuantity, addQuantity) {
                        if (!isNaN(parseInt(oldQuantity)) && !isNaN(parseInt(addQuantity))) {
                            return parseInt(oldQuantity) + parseInt(addQuantity);
                        }
                        return "";
                    }
                },
                validate: {
                    compareWith: "oldQuantity",
                    compare: function (quantity, oldQuantity) {
                        if (!isNaN(parseInt(quantity)) && !isNaN(parseInt(oldQuantity))) {
                            return parseInt(quantity) > parseInt(oldQuantity);
                        }
                        return false;
                    }
                },
            }
        ]
    };
};

// Legacy export for backward compatibility
const fields = (t) => ({
    config: {columns: 1},
    fields: [
        {
            name: "oldQuantity",
            label: t ? t("forms.current_state") : "Obecny stan",
            type: "number",
            mandatory: true,
            readOnly: true,
            column: 1,
        },
        {
            name: "addQuantity",
            label: t ? t("forms.added_quantity") : "Wprowadzana ilość",
            type: "number",
            mandatory: true,
            column: 1,
            validate: function (value) {
                return parseInt(value) > 0;
            }

        },

        {
            name: "quantity",
            label: t ? t("forms.state_after_addition") : "Stan po wprowadzeniu",
            type: "number",
            readOnly: true,
            column: 1,
            autoComplete: {
                triggers: ["oldQuantity", "addQuantity"],
                calculation: function (oldQuantity, addQuantity) {
                    if (!isNaN(parseInt(oldQuantity)) && !isNaN(parseInt(addQuantity))) {
                        return parseInt(oldQuantity) + parseInt(addQuantity);
                    }

                    return "";

                }
            },
            validate: {
                compareWith: "oldQuantity",
                compare: function (quantity, oldQuantity) {
                    if (!isNaN(parseInt(quantity)) && !isNaN(parseInt(oldQuantity))) {
                        return parseInt(quantity) > parseInt(oldQuantity);
                    }

                    return false;

                }
            },
        }

    ]
});

export default fields;
